
export default {
  name: 'TwoColumnTable',
  filters: {
      date(value) {
          const formattedDate =
              value &&
              value.substring(0, 4) +
                  '.' +
                  value.substring(4, 6) +
                  '.' +
                  value.substring(6, 8)

          return formattedDate
      },
  },
  props: {
      data: {
          type: Array,
          default: () => {
              return []
          },
      },
      newsItem: Array,
  },
  data() {
      return {
          renderLength: 10,
          isMore: false,
      }
  },
  computed: {
      filteredItems() {
          const slice =
              this.data &&
              this.data.slice(
                  0,
                  this.renderLength ? this.renderLength : this.data.length
              )

          return slice
      },
  },
  methods: {
      moreButton() {
          this.isMore = true
          this.renderLength = 0
      },
      hideButton() {
          this.isMore = false
          this.renderLength = 10
      },
  },
}
